/* eslint-disable @typescript-eslint/naming-convention */
export enum ACCESSORIES_TYPES {
    fixe = 'fixe',
    maison_connectee = 'maison-connectee',
    audio = 'audio',
    coques = 'coques-protections',
    stockage = 'charge-stockage',
    montres = 'montre-bracelet-connectes',
}

export const FAI_ACCESSORIES = [ACCESSORIES_TYPES.maison_connectee, ACCESSORIES_TYPES.fixe];
